<template>
	<div>

		<div class="data-count-model es es-ver">
			<div class="es-f1"></div>
			<div class="con es es-ver" style="overflow: auto;" v-if="data_model == 3">
				<div class="es ">
					<div class="es" style="width: var(--base-px-100);;">
						<div class="es es-ac" @click="data_model = 2">
							<img src="../../assets/course/ret-black.png"
							     style="width: var(--base-px-10);height: var(--base-px-10);"></img>
							<div class="" style="color: #999;margin-left: var(--base-px-5);">返回</div>
						</div>
					</div>
<!--					<div class="es-f1" style="font-size: var(&#45;&#45;base-px-16);text-align: center;font-weight: bold;">-->
<!--						选择标签-->
<!--					</div>-->
					<div class="" style="width: var(--base-px-100);;">

					</div>
				</div>

				<div class="es-bc-tint es-f1 es-oa"
				     style="padding: 0 var(--base-px-8);border-radius: var(--base-px-8);background: #F7FAFE;margin-top: var(--base-px-16);overflow-y: auto;">
					<div class="label-row" v-for="v, i in label">
						<div class="es es-ac">
							<!-- <div class="" style="width: var(--base-px-6);height: var(--base-px-20);background-color: red;"></div> -->
							<img src="../../assets/course/table-1.png"
							     style="width: var(--base-px-8);height: var(--base-px-24)"></img>
							<div style="margin-left: var(--base-px-5);font-weight: bold;">{{ v.groupName }}</div>
						</div>

						<div style="padding: 0 var(--base-px-8);font-size: var(--base-px-12);">
							<div class="es es-ac" style="padding: var(--base-px-6) 0;" v-for="vv, ii in v.tags" @click="vv.ac=!vv.ac">
								<div class="es-f1" style="font-size: var(--base-px-14);margin-left: var(--base-px-5);"
								     :style="vv.ac?'color:#1A89F9':''">{{ vv.name }}
								</div>
								<div class="" v-if="vv.ac" style="width: var(--base-px-12);">
									<img src="../../assets/course/table-ac.png"
									     style="width: var(--base-px-12);height: var(--base-px-10)"></img>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div style="padding: var(--base-px-8) var(--base-px-20);">
					<div class="es es-ac es-pc es-bc" style="border-radius: var(--base-px-8);height: var(--base-px-40)"
					     @click="setAc()">确认
					</div>
				</div>

			</div>
			<div class="con es es-ver" style="overflow: auto;" v-else>
				<div class="es " style="padding-bottom: var(--base-px-10);">
					<div class="" style="width: var(--base-px-10);;"></div>
					<div class="es-f1" style="font-size: var(--base-px-16);text-align: center;">
						数据统计
					</div>
					<div class="" @click="closeModel()" style="width: var(--base-px-14);overflow: auto;">
						<img src="../../assets/course/close.png" style="width: var(--base-px-14);height: var(--base-px-14);"></img>
					</div>
				</div>

				<div class="es-f1 es es-ver">

					<div class="nav es" style="font-weight: 500;">
						<div class="es-f1 es  es-ac es-pc" :class="data_model == 1 ? 'ac' : ''" @click="setIndex(1)">课程数据
						</div>
						<div class="es-f1 es  es-ac es-pc" :class="data_model == 2 ? 'ac' : ''" @click="setIndex(2)">参与记录
						</div>
					</div>

					<div v-if="data_model == 1">
						<div class="">
							<div class="count-title">课程统计</div>
							<div class="count-block es es-ac">
								<div class="es es-ver es-ac es-pc">
									<div class="num">
										<span>{{ info.watchNumber }}</span>
										<span>人</span>
									</div>
									<div>观看人数</div>
								</div>
								<div class="es es-ac es-pc es-f1">
									<div class="count-line"></div>
								</div>
								<div class="es es-ver es-ac es-pc">
									<div class="num">
										<span>{{ info.finishedNumber }}</span>
										<span>人</span>
									</div>
									<div>完播人数</div>
								</div>
								<div class="es es-ac es-pc es-f1">
									<div class="count-line"></div>
								</div>
								<div class="es es-ver es-ac es-pc">
									<div class="num">
										<span>{{ info.finishedRate }}</span>
										<span>%</span>
									</div>
									<div>完播率</div>
								</div>
							</div>
						</div>
						<div class="">
							<div class="count-title">答题统计</div>
							<div class="count-block es es-ac">
								<div class="es es-ver es-ac es-pc">
									<div class="num">
										<span>{{ info.questionNumber }}</span>
										<span>人</span>
									</div>
									<div>答题人数</div>
								</div>
								<div class="es es-ac es-pc es-f1">
									<div class="count-line"></div>
								</div>
								<div class="es es-ver es-ac es-pc">
									<div class="num">
										<span>{{ info.correctNumber }}</span>
										<span>人</span>
									</div>
									<div>正确人数</div>
								</div>
								<div class="es es-ac es-pc es-f1">
									<div class="count-line"></div>
								</div>
								<div class="es es-ver es-ac es-pc">
									<div class="num">
										<span>{{ info.correctRate }}</span>
										<span>%</span>
									</div>
									<div>正确率</div>
								</div>
							</div>
						</div>
						<div class="">
							<div class="count-title">奖励统计</div>
							<div class="count-block es es-ac">
								<div class="es es-ver es-ac es-pc es-f1">
									<div class="num">
										<span v-if="is_open_points">{{ info.integrateUserNumber }}</span>
										<span v-else>{{ info.rewardNumber }}</span>
										<span>个</span>
									</div>
									<div>考核奖励数</div>
								</div>
								<div class="es es-ac es-pc" style="width: var(--base-px-1);overflow: hidden;">
									<div class="count-line"></div>
								</div>
								<div class="es es-ver es-ac es-pc es-f1">
									<div class="num">
										<span>{{ info.rewardMoney }}</span>
										<span>元</span>
									</div>
									<div>考核金额</div>
								</div>
								<template v-if="is_open_points">
									<div class="es es-ac es-pc" style="width: var(--base-px-1);overflow: hidden;">
									<div class="count-line"></div>
								</div>
								<div class="es es-ver es-ac es-pc es-f1">
									<div class="num">
										<span>{{ info.integrateTotal }}</span>
									</div>
									<div>考核积分</div>
								</div>
								</template>
							</div>
						</div>

					</div>
					<div v-if="data_model == 2" class="es es-ver es-f1">
						<div class="es es-ac" style="margin-top: var(--base-px-12);;">
							<div class="es-f1 es-ipt" style="border-radius: var(--base-px-100);background-color: #F1F1F1;">
								<input style="background: #F1F1F1;font-size: var(--base-px-12);" v-model="kwd.search"
								       placeholder="请输入昵称进行搜索"/>
							</div>
							<div @click="setSeach()" class="count-search-btn es es-ac es-pc" style="margin-left: var(--base-px-10);">
								查询
							</div>
						</div>

						<div class="es" style="padding:8px 0;">
							<div class="es es-ac">
								<template v-for="v in nav">
									<div class="es es-ac es-pc es-ver" style="" @click="setNav(v.id)">
										<div style="font-size: var(--base-px-14);"
										     :style="v.id == kwd.type ? 'color:#1a89f9;font-weight: bold;' : 'font-weight: 500'">
											{{ v.name || v }}
										</div>
										<div class=""
										     style="margin-top: var(--base-px-2);; width: var(--base-px-22);height: var(--base-px-2);"
										     :style="v.id == kwd.type ? 'background:#1a89f9;' : ''"></div>
									</div>
									<div class="" style="width: var(--base-px-14);"></div>
								</template>
							</div>
							<div class="es-f1"></div>
<!--							<div class="es es-ac" @click="data_model = 3">-->
<!--								<img src="../../assets/course/table-2.png"-->
<!--								     style="width: var(&#45;&#45;base-px-12);height: var(&#45;&#45;base-px-12);margin-right: var(&#45;&#45;base-px-4);"></img>-->
<!--								<div style="color: #1A89F9;">选择标签</div>-->
<!--							</div>-->
						</div>

						<div class="es es-ac">
							<div style="margin-right: var(--base-px-8);">注册时间</div>
							<div class="es-f1 es-ipt es es-ac es-pc"
							     style="border-radius: var(--base-px-6);background-color: #F1F1F1;" @click="setTime('start')">
								<!-- <input disabled v-model="kwd.start_time" placeholder="请选择起始时间" /> -->
								<div style="font-size: var(--base-px-12);color: #666666;">{{
										kwd.start_time ? kwd.start_time : '请选择起始时间'
									}}
								</div>
							</div>
							<div class="" style="margin: 0 var(--base-px-10);">-</div>
							<div class="es-f1 es-ipt es es-ac es-pc"
							     style="border-radius: var(--base-px-6);background-color: #F1F1F1;" @click="setTime('end')">
								<!-- <input disabled v-model="kwd.end_time" placeholder="请选择结束时间" /> -->
								<div style="font-size: var(--base-px-12);color: #666666;">{{
										kwd.end_time ? kwd.end_time : '请选择结束时间'
									}}
								</div>
							</div>
						</div>
						<div class="es" style="padding: var(--base-px-10) 0;">
							共计：<span style="color: #1a89f9;">{{ count }}</span>个客户
						</div>

						<div class="es-f1 es-oa scroll-container" style="overflow-y: auto;" ref="scrollContainer"
						     @scroll="handleScroll">
							<div class="es-bc-tint" v-for="v in list"
							     style="border-radius: var(--base-px-8);padding: var(--base-px-8);margin-bottom: var(--base-px-10);background: #F7FAFE;"
							     @click="seeContactDetail(v.wx_external_userid)">
								<div class="es es-ac">
									<img :src="v.avatar"
									     style="border-radius: var(--base-px-100);height: var(--base-px-52);width: var(--base-px-52);"></img>
									<div class="es-f1" style="margin-left: var(--base-px-10);">
										<div class="es">
											<div style="font-weight: 500;margin-right: var(--base-px-5);">{{ v.name }}</div>
											<div style="color: #30D53A;">@微信</div>
										</div>
										<div style="font-size: var(--base-px-12);color: #555;margin-top: var(--base-px-4);">
											注册时间：{{ v.register_time }}
										</div>
									</div>
<!--									<div class="count-chat-btn es es-ac" style="font-size: var(&#45;&#45;base-px-12);color: rgb(26, 137, 249);">-->
<!--										<img style="width: var(&#45;&#45;base-px-12);height: var(&#45;&#45;base-px-12);margin-right: var(&#45;&#45;base-px-4);"-->
<!--										     src="../../assets/course/message.png"></img>-->
<!--										聊天-->
<!--									</div>-->
								</div>
								<div v-if="kwd.type!=4" class=""
								     style="background-color: white;padding:8px;border-radius: var(--base-px-8);margin-top: var(--base-px-8);">
									<div style="color: #333333;font-size: var(--base-px-14);">看课详情</div>
									<div style="color: #999999;font-size: var(--base-px-12);">
										<div class="es" style="margin-top:3px;">
											<div class="es-f1">开始时间：</div>
											<div style="color: #333333;" class="">
												{{ v.watch_class_start_time ? v.watch_class_start_time : '-' }}
											</div>
										</div>
										<div class="es" style="margin-top:3px;">
											<div class="es-f1">结束时间：</div>
											<div style="color: #333333;" class="">
												{{ v.watch_class_end_time ? v.watch_class_end_time : '-' }}
											</div>
										</div>
										<div class="es" style="margin-top:3px;">
											<div class="es-f1">看课时长：</div>
											<div style="color: #333333;" class="">{{ v.watch_class_total_watch_time }}</div>
										</div>

									</div>
								</div>

								<div v-if="kwd.type==1">
									<div class="es es-ac"
									     style="margin-top: var(--base-px-8);font-size: var(--base-px-14);color: #333333;"
									     v-if="v.is_red==0">
										<div class="">领取状态:</div>
										<div class="es-f1" style="color: #1A89F9;">未领取</div>
									</div>
									<div class="es es-ac"
									     style="margin-top: var(--base-px-8);font-size: var(--base-px-14);color: #333333;"
									     v-if="v.is_red==1">
										<div class="">领取状态:</div>
										<div class="es-f1" style="color: #1A89F9;">领取中</div>
									</div>
									<div class="es es-ac"
									     style="margin-top: var(--base-px-8);font-size: var(--base-px-14);color: #333333;"
									     v-if="v.is_red==2">
										<div class="">领取状态:</div>
										<div class="es-f1" style="color: #1A89F9;">已领取</div>
										<div class="">领取时间:</div>
										<div style="color: #1A89F9;">{{ v.red_order_time ?? '' }}</div>
									</div>
									<div class="es es-ac"
									     style="margin-top: var(--base-px-8);font-size: var(--base-px-14);color: #333333;"
									     v-if="v.is_red==3">
										<div class="">领取状态:</div>
										<div class="es-f1" style="color: #1A89F9;">领取失败</div>
										<div class="">领取时间:</div>
										<div style="color: #1A89F9;">{{ v.red_order_time ?? '' }}</div>
									</div>
								</div>
								<div v-if="kwd.type==2">
									<div class="es es-ac"
									     style="margin-top: var(--base-px-8);font-size: var(--base-px-14);color: #333333;">
										<div class="">考核状态:</div>
										<div class="es-f1" style="color: #1A89F9;">考核错误</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<van-popup v-model="showDate" position="bottom" class="group-d" :style="{ height: '53%' }">
			<van-datetime-picker
				v-model="currentDate"
				type="date"
				class="h-full"
				title="注册时间"
				:min-date="minDate"
				:max-date="maxDate"
				:visible-item-count="10"
				@cancel="onDateCancel"
				@confirm="onDateConfirm"
			/>
		</van-popup>
	</div>
</template>

<script>
import {trainLessonDataStatistics, trainLessonJoinLogList} from "@/api/course"
import {employeeIndex, contactTagList, store} from "@/api/channelCode";
import {openEnterpriseChat, openUserProfile} from '@/utils/wxCodeAuth'

export default {
	data() {
		return {
			data_model: 1,

			info: false,
			list: false,
			count: 0,
			kwd: {
				train_lesson_id: '',
				page: 1,
				perPage: 10,
				search: '',
				type: 1,
				tags: '',
				start_time: '',
				end_time: '',
			},
			nav: [
				{
					id: 1,
					name: '考核正确'
				},
				{
					id: 2,
					name: '仅完播'
				},
				{
					id: 3,
					name: '未完播'
				},
				{
					id: 4,
					name: '未观看'
				},
			],
			label: false,
			minDate: new Date(2000, 0, 1),
			maxDate: new Date(2099, 10, 1),
			currentDate: new Date(),
			showDate: false,
			timeType: 'start',
			allLoaded: false,
			is_open_points: process.env.VUE_APP_IS_OPEN_POINTS == '1' ? true : false,
		}
	},
	props: [
		'data', 'train_lesson_id'
	],
	created() {
		this.info = this.data;
		this.kwd.train_lesson_id = this.train_lesson_id;
		this.data_model = 1;
		// contactTagList().then(res => {
		// 	res.data.forEach(item => {
		// 		item.tags.forEach(item1 => {
		// 			item1.ac = false
		// 		})
        //
		// 	})
		// 	console.log(res.data);
		// 	this.label = res.data;
		// })
		// console.log('data', this.data);
	},
	mounted() {

	},
	updated() {

	},
	methods: {
		openModel: function () {
			console.log('xxxxxxxxx')
		},
		closeModel: function () {
			this.$emit("close", '1');
		},
		setIndex(index) {
			if (index == 1) {
				this.getOne();
			} else if (index == 2) {
				this.getTwo();
			}
		},
		getOne() {
			trainLessonDataStatistics({train_lesson_id: this.kwd.train_lesson_id}).then(r => {
				this.info = r.data;
				this.data_model = 1;
			})
		},
		getTwo() {
			this.allLoaded = false;
			this.kwd.page = 1;
			trainLessonJoinLogList(this.kwd).then(r => {
				let num = 0;
				r.data.list.forEach(item => {
					if (item.watch_class_total_watch_time * 1 >= 60 * 60) {
						let h = Math.floor(item.watch_class_total_watch_time * 1 / (60 * 60));
						let i = (item.watch_class_total_watch_time * 1 % (60 * 60)) * 1;
						let s = (i * 1 % 60) * 1;
						i = (Math.floor(i * 1 / 60)) * 1;
						item.watch_class_total_watch_time = h + '小时' + i + '分' + s + '秒';
					} else if (item.watch_class_total_watch_time * 1 >= 60) {
						let s = (item.watch_class_total_watch_time * 1 % 60) * 1;
						let i = (Math.floor(item.watch_class_total_watch_time * 1 / 60)) * 1;
						item.watch_class_total_watch_time = i + '分' + s + '秒';
					} else {
						item.watch_class_total_watch_time = item.watch_class_total_watch_time * 1 + '秒';
					}
					num++;
				})
				if (num == 0) {
					this.allLoaded = true;
				}
				this.list = r.data.list;
				this.count = r.data.count;
				this.data_model = 2;
			})
		},
		setNav(id) {
			this.kwd.type = id;
			this.getTwo();
		},
		setSeach() {
			this.getTwo()
		},
		setAc() {
			let label = this.label;
			let tags = '';
			label.forEach(item => {
				item.tags.forEach(item1 => {
					if (item1.ac) {
						tags += tags ? ',' + item1.id : item1.id;
					}
				})
			})

			this.kwd.tags = tags;

			this.setIndex(2);
		},
		setTime(type) {
			this.timeType = type;
			this.showDate = true;
		},
		onDateCancel(e) {
			this.kwd.start_time = '';
			this.kwd.end_time = '';
			this.showDate = false
		},
		onDateConfirm(e) {
			const date = this.currentDate;
			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的，所以要加1
			const day = date.getDate().toString().padStart(2, '0');
			if (this.timeType == 'start') {
				this.kwd.start_time = `${year}-${month}-${day}`;
			} else {
				this.kwd.end_time = `${year}-${month}-${day}`;
			}
			this.showDate = false;
			this.getTwo();
		},
		handleScroll: function (e) {
			const container = this.$refs.scrollContainer;

			if (container.scrollTop > 200) {
				this.loadMoreData();
			}
		},
		async loadMoreData() {
			if (this.allLoaded) return; // 如果所有数据已加载，则不执行
			this.allLoaded = true;
			this.kwd.page = this.kwd.page * 1 + 1;
			trainLessonJoinLogList(this.kwd).then(r => {
				let num = 0;
				let list = this.list;
				r.data.list.forEach(item => {
					if (item.watch_class_total_watch_time * 1 >= 60 * 60) {
						let h = Math.floor(item.watch_class_total_watch_time * 1 / (60 * 60));
						let i = item.watch_class_total_watch_time * 1 % (60 * 60);
						let s = i * 1 % 60;
						i = Math.floor(i * 1 / 60);
						item.watch_class_total_watch_time = h + '小时' + i + '分' + s + '秒';
					} else if (item.watch_class_total_watch_time * 1 >= 60) {
						let s = item.watch_class_total_watch_time * 1 % 60;
						let i = Math.floor(item.watch_class_total_watch_time * 1 / 60);
						item.watch_class_total_watch_time = i + '分' + s + '秒';

					} else {
						item.watch_class_total_watch_time = item.watch_class_total_watch_time + '秒';
					}
					num++;
					list.push(item);
				})
				if (num == 0) {
					this.allLoaded = true;
				} else {
					this.allLoaded = false;
				}
				this.list = list;
				this.count = r.data.count;
				this.data_model = 2;
			})

		},
		async seeContactDetail(user_id) {
			await openEnterpriseChat('', user_id, '')

			// await openUserProfile(2, user_id)
		},
	},
}
</script>

<style>
.es {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	position: relative;
}

.es-ver {
	flex-direction: column;
}

.es-ac {
	align-items: center;
}

.es-ae {
	align-items: flex-end;
}

.es-pc {
	justify-content: center;
}

.es-pe {
	justify-content: flex-end;
}

.es-f1 {
	flex-grow: 1;
}

.es-f2 {
	flex-grow: 2;
}

.es-f3 {
	flex-grow: 3;
}

.es-f4 {
	flex-grow: 4;
}

.es > div,
.es > div {
	flex-shrink: 0;
}

.es-f1,
.es-f2,
.es-f3,
.es-f4 {
	flex-shrink: 1 !important;
	overflow: hidden;
}

.es-block {
	position: relative;
	overflow: hidden;
}

.es-block > div:nth-child(1) {
	padding-top: 100%;
	width: 100%;
}

.es-block > div:nth-child(2) {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	overflow: hidden;
	z-index: 1;
}

.es-block > div:nth-child(3) {
	position: absolute;
	overflow: hidden;
	z-index: 2;
}

.es-omit,
.es-omit-1 {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.data-model-item {
	height: var(--base-px-20);
	border-radius: var(--base-px-8);
	margin: var(--base-px-3);
}

.data-model-item-ac {
	background-color: white;
	color: #1A89F9;
}

.data-count-model {
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.25);
	z-index: 999;
}

.data-count-model .con {
	height: 80%;
	background-color: white;
	border-radius: var(--base-px-16) var(--base-px-16) 0 0;
	padding: var(--base-px-14) var(--base-px-14);
}

.data-count-model .nav {
	padding: var(--base-px-4);
	background-color: #f3f3f3;
	border-radius: var(--base-px-8);
}

.data-count-model .nav > div {
	height: var(--base-px-32);
	border-radius: var(--base-px-8);
}

.data-count-model .nav > div.ac {
	background-color: white;
	color: #1a89f9;
	font-weight: bold;
}

.count-block {
	background: #F7FAFE;
	/* background-color: rgba(26, 137, 249, 0.2); */
	border-radius: var(--base-px-8);
	color: #1a89f9;

}

.es-bc-tint {
	background-color: rgba(26, 137, 249, 0.2);
}

.count-search-btn {
	background-color: #1a89f9;
	color: white;
	height: var(--base-px-36);
	width: var(--base-px-75);
	border-radius: var(--base-px-100);
}

.count-chat-btn {
	border: var(--base-px-1) #1a89f9 solid;
	border-radius: var(--base-px-8);
	height: var(--base-px-32);
	padding: 0 var(--base-px-12);
}

.count-block > div {
	width: 33%;
	font-size: var(--base-px-13);
	height: var(--base-px-68);
}

.count-block span:nth-child(1) {
	font-size: var(--base-px-22);
}

.count-block span:nth-child(2) {
	font-size: var(--base-px-12);
}

.count-title {
	font-size: var(--base-px-13);
	margin-bottom: var(--base-px-5);
	margin-top: var(--base-px-20);
}

.count-line {
	height: var(--base-px-48);
	background: linear-gradient(180deg, #FFFFFF 0%, #1A89F9 52%, #FFFFFF 100%);
	width: var(--base-px-1);
}

.es-ipt {
	overflow: hidden;
	background-color: #f7f8fa;
}

.es-ipt,
.es-ipt input {
	height: var(--base-px-36);
}

.es-ipt input {
	padding: 0 var(--base-px-12);
	font-size: var(--base-px-14);
	width: calc(100% - var(--base-px-24));
	background-color: #f7f8fa;
}

input {
	border: none !important;
}

.label-row {
	padding: var(--base-px-14) 0 var(--base-px-8) 0;
	border-top: var(--base-px-1) #f7f8fa solid;
}

.label-row:nth-child(1) {
	border-top: none;
}

.es-c {
	color: #1a89f9;
}

.es-bc {
	background-color: #1a89f9;
	color: white;
}
</style>
